import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { IconButton, Paper } from "@mui/material";
import { OrgChart } from "d3-org-chart";
import { useLayoutEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { RipplingUserInfo } from "../../../types";
import CustomNodeContent from "./customNodeContent";

// Props interface for OrganizationChart component
interface OrganizationChartProps {
  data: RipplingUserInfo[]; // Update with appropriate type for data
}

const OrganizationChart: React.FC<OrganizationChartProps> = (props) => {
  // Ref to hold the container element for d3 chart
  const d3Container = useRef<HTMLDivElement>(null);

  // Use layout effect to create and update the chart
  useLayoutEffect(() => {
    // Create a new instance of OrgChart
    const chart = new OrgChart();
    // Check if data and container ref are available
    if (props.data && d3Container.current) {
      chart
        .container(d3Container.current)
        .data(props.data)
        .nodeWidth(() => 300)
        .nodeHeight(() => 120)
        .childrenMargin(() => 100)
        .compactMarginBetween(() => 135)
        .compactMarginPair(() => 130)
        .neighbourMargin(() => 120)
        // Render custom node content using ReactDOMServer
        .nodeContent((d) => {
          return ReactDOMServer.renderToStaticMarkup(
            <CustomNodeContent {...d} />
          );
        })
        .render();

      chart.fit();
    }
  }, [props.data]); // Re-render when data changes

  // Render the container for d3 chart
  return (
    <div className="org-chart-container">
      <div className="org-chart" ref={d3Container} />
    </div>
  );
};

export default OrganizationChart;
